








import { Component } from 'vue-property-decorator';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { getBillingIsPending } from '@/utils/billing';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import BillingService from '@/api/BillingService';
import BusinessService from '@/api/BusinessService';
import { treatError } from '@/utils';
import SellCoinsService from '@/api/SellCoinsService';
import SellCoinsModalProps from './SellCoinsModalProps.vue';

@Component({
  components: { Page },
})
export default class RemoteWaiting extends SellCoinsModalProps {
  businessService = new BusinessService();
  sellCoinsService = new SellCoinsService();

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'] || {};
  }

  openBillingWelcomeModal(props: any) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'coinNetworkWelcomeModal',
        hideCancelButton: false,
        icon: '',
        mobileFullScreen: true,
        fullWidth: true,
      }),
      {
        subscription: props.subscription,
        ctaText: props.ctaText,
        ctaClick: props.ctaClick,
      },
    );
  }

  openLoyaltyModal(props: any) {
    // this.$store.dispatch(
    //   'business/SET_REWARD_STATUS',
    //   event.data.data.rewardData
    // );

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: `toggleRewardsModal`,
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: true,
        fullWidth: true,
        removeBackground: true,
      }),
      {
        mobilePositionBottom: true,
        activeRewards: props.activeRewards,
        type: 'physical',
        onSuccess: async () => {
          window.parent.postMessage({ type: 'loyalty:toggle', data: {} }, '*');
          window.parent.postMessage(
            {
              type: 'myprograms:reload',
              data: {
                overviewData: {
                  hasCoinsBack: props.activeRewards,
                },
              },
            },
            '*',
          );
        },
        group: {
          id: 'loyalty-program',
        },
        origin: 'switch',
      },
    );
  }

  async openBillingDeactivationModal({ origin }: { origin: string }) {
    const billingService = new BillingService();
    const { overview, features } =
      await billingService.getOverviewAndActivedFeatures();

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: `coinNetworkDeactivationModal`,
        hideCancelButton: false,
        icon: '',
        mobileFullScreen: true,
        removeBackground: true,
      }),
      {
        subscription: overview,
        features,
        origin,
      },
    );
  }

  async openSubscriptionModal(props: any) {
    const billingService = new BillingService();
    const modal = getBillingIsPending() ? 'Acceptance' : 'Reactivation';

    const { overview, features } =
      await billingService.getOverviewAndActivedFeatures(
        modal !== 'Reactivation',
      );

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: `coinNetwork${modal}Modal`,
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: true,
        fullWidth: true,
        removeBackground: true,
      }),
      {
        subscription: overview,
        features,
        welcomeCtaClick: () => {
          if (props.goTo) {
            window.parent.postMessage(
              { type: 'portal-router-push', data: { path: props.goTo } },
              '*',
            );
          }
        },
        welcomeCtaText: props.welcomeCtaText,
        ...props,
      },
    );
  }

  treatErrorSellCoins(error: any) {
    if (
      error.response.data.message[0].translation ===
      'exceptions.business.sellCoinsNotAvailable'
    ) {
      this.$notification(
        'You need to connect an online provider first.',
        'error',
      );
      return;
    }

    treatError(error);
  }

  updateBusinessData(data: any) {
    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...this.businessInfo,
      sellCoins: data.sellCoins,
    });
  }

  openGiftCardModal(props: any) {
    this.iconName = 'warning.svg';

    this.campaign = {
      ...props.campaign,
      name: props.campaign.title,
      incentiveValue: props.campaign.data.incentiveValue,
      isCampaignActive: props.isCampaignActive,
    };
    this.automaticCampaign = props.automaticCampaign;

    if (props.isCampaignActive) {
      this.deactivateCampaign();
    } else {
      this.handleActivation();
    }
  }

  openWithdrawModal(props: any) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'withdrawSellCoins',
        fullWidth: true,
        removeBackground: true,
      }),
      {
        data: props.data,
        onConfirm: async () => {
          window.parent.postMessage({ type: 'myprograms:stats:reload' }, '*');
        },
      },
    );
  }

  openStripeRedirectModal(props: any) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'stripeRedirect',
        fullWidth: true,
        removeBackground: true,
      }),
      {
        onConfirm: async () => {
          this.gotoStripeLink(props.url);
        },
      },
    );
  }

  gotoStripeLink(url = this.$store.state.stripe.connectURL) {
    window.parent.open(`${url}`, '_self');
  }

  openEditOfferModal(props: any) {
    const { offer, index } = props;

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'editAIOffer',
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false,
        fullWidth: true,
        removeBackground: true
      }),
      {
        offer,
        index,
        editOffer: (offerEdited: any) => {
          window.parent.postMessage(
            {
              type: 'offer:updated',
              data: {
                index,
                offer: {
                  ...offerEdited,
                  image: {
                    url: offerEdited.imageSrc,
                    id: offerEdited.imageId
                  }
                }
              }
            },
            '*'
          );
        }
      }
    );
  }

  openModal(data: any) {
    const { name, props } = data;

    switch (name) {
      case 'loyalty-modal':
        return this.openLoyaltyModal(props);
      case 'subscription-modal':
        return this.openSubscriptionModal(props);
      case 'gift-card-modal':
        return this.openGiftCardModal(props);
      case 'withdraw-modal':
        return this.openWithdrawModal(props);
      case 'stripe-redirect-modal':
        return this.openStripeRedirectModal(props);
      case 'billing-welcome-modal':
        return this.openBillingWelcomeModal(props);
      case 'billing-deactivation-modal':
        return this.openBillingDeactivationModal(props);
      case 'edit-offer-modal':
        return this.openEditOfferModal(props);
      default:
        throw new Error(`Invalid modal ${name}`);
    }
  }

  onMessage(event: MessageEvent) {
    const { type, data } = event.data;

    switch (type) {
      case 'openModal':
        return this.openModal(data);
      case 'updateModalPosition':
        return;
      default:
        console.debug(`Invalid event ${type}`);
        return;
    }
  }

  created() {
    window.addEventListener('message', this.onMessage);
    window.parent.postMessage({ type: 'iframe:modal:ready', data: {} }, '*');
  }

  beforeDestroy() {
    window.removeEventListener('message', this.onMessage);
  }
}
